import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import s from './FormField.module.css';

type FormTextareaProps = ComponentPropsWithoutRef<'textarea'> & {
  /** react-hook-form field error message — adds red border. */
  error?: string;
};

/**
 * Textarea compatible with react-hook-form's `register` (uses forwardRef).
 *
 * @example
 * <FormField label="Текст" required error={errors.text?.message}>
 *   <FormTextarea {...register('text')} rows={4} placeholder="Текст..." />
 * </FormField>
 */
export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ error, className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={`${s.textarea} ${error ? s.hasError : ''} ${className ?? ''}`}
      {...props}
    />
  )
);

FormTextarea.displayName = 'FormTextarea';
